import React, { useState } from 'react';
import { PageHeader, Card, FormGroup, Input, Select, Button, DataTable, ActionButtons, SectionDivider, Badge } from '../../components/common/UIComponents';
import { ChargesController } from '../../controllers';

const chargeTypes = ['Sinking Fund', 'Repair Fund', 'Water Charges', 'Property Tax', 'Parking Charges',
  'Non Occupancy Charges', 'Education and Training Fund', 'SC', 'contri', 'Terrace shade charges',
  'nalla charges', 'gutter charges2', 'Wall Painting Charges', 'Society light Charge', 'kids Play Ground Charge'];

export default function SetChargesPage() {
  const [records, setRecords] = useState(ChargesController.getAll());
  const [form, setForm] = useState({ type: '', head: '', group: '', subGroup: '', alias: '', amount: '', applicableTo: 'Both', calculateInterest: 'Yes', gstApplicable: false, basedOn: 'Fixed', applicableAll: 'Yes' });
  const [editing, setEditing] = useState(null);

  const refresh = () => setRecords(ChargesController.getAll());

  const handleSubmit = () => {
    if (!form.type) return;
    const rec = { ...form, amount: parseFloat(form.amount) || 0 };
    editing ? ChargesController.update(editing, rec) : ChargesController.add(rec);
    setForm({ type: '', head: '', group: '', subGroup: '', alias: '', amount: '', applicableTo: 'Both', calculateInterest: 'Yes', gstApplicable: false, basedOn: 'Fixed', applicableAll: 'Yes' });
    setEditing(null);
    refresh();
  };

  const columns = [
    { key: 'id', label: '#' },
    { key: 'type', label: 'Charge Type' },
    { key: 'amount', label: 'Amount', className: 'td-mono', render: r => <span className="td-amount credit">₹{r.amount?.toLocaleString('en-IN')}</span> },
    { key: 'basedOn', label: 'Based On', render: r => <Badge color="blue">{r.basedOn || 'fixed'}</Badge> },
    { key: 'applicableTo', label: 'Applicable To' },
    { key: 'applicableAll', label: 'Applicable All', render: r => <Badge color={r.applicableAll === 'YES' || r.applicableAll === 'Yes' ? 'green' : 'amber'}>{r.applicableAll}</Badge> },
    { key: 'actions', label: 'Actions', render: row => (
      <ActionButtons
        onEdit={() => { setForm({ type: row.type, head: row.head || '', group: row.group || '', subGroup: row.subGroup || '', alias: row.alias || '', amount: row.amount?.toString(), applicableTo: row.applicableTo || 'Both', calculateInterest: row.calculateInterest || 'Yes', gstApplicable: row.gstApplicable || false, basedOn: row.basedOn || 'Fixed', applicableAll: row.applicableAll || 'Yes' }); setEditing(row.id); }}
        onDelete={() => { ChargesController.delete(row.id); refresh(); }}
      />
    )},
  ];

  return (
    <div className="fade-in">
      <PageHeader title="Set Charges" description="Configure billing charges for members" />

      <Card title={editing ? 'Edit Charge' : 'Add Charge'} style={{ marginBottom: 20 }}>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Select Charge Type" required>
            <Select value={form.type} onChange={e => setForm(p => ({ ...p, type: e.target.value }))} options={chargeTypes} placeholder="Select" />
          </FormGroup>
          <FormGroup label="Select Account Head" required>
            <Select value={form.head} onChange={e => setForm(p => ({ ...p, head: e.target.value }))} options={['Assets', 'Liabilities', 'Incomes', 'Expenses']} placeholder="Select" />
          </FormGroup>
          <FormGroup label="Select Account SubGroup" required>
            <Select value={form.subGroup} onChange={e => setForm(p => ({ ...p, subGroup: e.target.value }))} options={['Contributions', 'Other Income', 'Expenses']} placeholder="Select" />
          </FormGroup>
          <FormGroup label="Alias Name" required>
            <Input placeholder="Enter Alias Name" value={form.alias} onChange={e => setForm(p => ({ ...p, alias: e.target.value }))} />
          </FormGroup>
          <FormGroup label="Amount" required>
            <Input type="number" placeholder="Enter Amount" value={form.amount} onChange={e => setForm(p => ({ ...p, amount: e.target.value }))} />
          </FormGroup>
          <FormGroup label="Based On">
            <Select value={form.basedOn} onChange={e => setForm(p => ({ ...p, basedOn: e.target.value }))} options={['Fixed', 'Square Foot']} placeholder="Fixed" />
          </FormGroup>
        </div>

        <div className="form-grid form-grid-4" style={{ marginBottom: 14 }}>
          <FormGroup label="Applicable To">
            <div className="radio-group">
              {['Both', 'Owner', 'Tenant'].map(v => (
                <label key={v} className="radio-label">
                  <input type="radio" name="applicableTo" value={v} checked={form.applicableTo === v} onChange={() => setForm(p => ({ ...p, applicableTo: v }))} /> {v}
                </label>
              ))}
            </div>
          </FormGroup>
          <FormGroup label="Calculate Interest">
            <div className="radio-group">
              {['Yes', 'No'].map(v => (
                <label key={v} className="radio-label">
                  <input type="radio" name="calcInt" value={v} checked={form.calculateInterest === v} onChange={() => setForm(p => ({ ...p, calculateInterest: v }))} /> {v}
                </label>
              ))}
            </div>
          </FormGroup>
          <FormGroup label="GST Applicable">
            <label className="checkbox-label"><input type="checkbox" checked={form.gstApplicable} onChange={e => setForm(p => ({ ...p, gstApplicable: e.target.checked }))} /> GST</label>
          </FormGroup>
          <FormGroup label="Applicable To All">
            <div className="radio-group">
              {['Yes', 'No'].map(v => (
                <label key={v} className="radio-label">
                  <input type="radio" name="appAll" value={v} checked={form.applicableAll === v} onChange={() => setForm(p => ({ ...p, applicableAll: v }))} /> {v}
                </label>
              ))}
            </div>
          </FormGroup>
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <Button onClick={handleSubmit}>{editing ? 'Update Charge' : 'Add Charge'}</Button>
          {editing && <Button variant="ghost" onClick={() => { setForm({ type: '', head: '', group: '', subGroup: '', alias: '', amount: '', applicableTo: 'Both', calculateInterest: 'Yes', gstApplicable: false, basedOn: 'Fixed', applicableAll: 'Yes' }); setEditing(null); }}>Cancel</Button>}
        </div>
      </Card>

      <SectionDivider />
      <DataTable title="Tarriff Set for Bill Generation Details" columns={columns} data={records}
        onSearch={q => ChargesController.search(q, ['type', 'applicableTo'])} />
    </div>
  );
}
